<template bindable="heading, intro">
  <div class="as-form-section">
    <h5 if.bind="heading">${heading}</h5>
    <h6 if.bind="intro" innerhtml="${intro}"></h6>
    <slot name="body"></slot>
    <div class="as-form-section__footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>
